"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem as ChakraMenuItem, Text, Flex } from "@chakra-ui/react";
import { textStyles } from "../../../theme/foundations/generated";
import { Avatar } from "../../atoms/Avatar";
import { IconButton } from "../../atoms/IconButton";
import { SvgSpriteConsumer } from "../../atoms/SvgSprite";
import { useNavigationContext } from "./NavigationContext";
const NavigationHeaderItem = (_a) => {
    var { userName, headerTitle, variant, closeButtonLabel } = _a, rest = __rest(_a, ["userName", "headerTitle", "variant", "closeButtonLabel"]);
    const { closeMenu, resetContentToParent } = useNavigationContext();
    return (_jsx(ChakraMenuItem, Object.assign({}, rest, { as: "div", sx: {
            // can't be disabled because the MenuItem contains a clickable element
            backgroundColor: "semantic.brand.primary  !important",
            cursor: "default !important",
        } }, { children: _jsxs(Flex, Object.assign({ justifyContent: "space-between", width: "inherit", mr: "-5" }, { children: [_jsxs(Flex, Object.assign({ alignItems: "center", ml: "-1" }, { children: [_jsx(Avatar, { name: userName, variant: variant }), _jsx(Text, Object.assign({ ml: "4", lineHeight: textStyles.body.largeBold.lineHeight, letterSpacing: textStyles.body.largeBold.letterSpacing, fontWeight: textStyles.body.largeBold.fontWeight, fontSize: textStyles.body.largeBold.fontSize, color: "semantic.text.inverse", maxWidth: "240px", noOfLines: 1, wordBreak: "break-all" }, { children: headerTitle }))] })), _jsx(IconButton, Object.assign({ variant: "deleteIcon", "aria-label": closeButtonLabel, onClick: () => {
                        resetContentToParent();
                        closeMenu();
                    }, icon: _jsx(SvgSpriteConsumer, { svgId: "delete24", size: 24 }) }, { children: "close" }))] })) })));
};
NavigationHeaderItem.displayName = "NavigationHeaderItem";
export default NavigationHeaderItem;
//# sourceMappingURL=NavigationHeaderItem.js.map